import { productApi } from './productApi';
import { normalizeProduct, getRetailPrice } from './productService';
import { normalizeCart, cartReducer } from './cartState';
import { saveFavoriteShop } from '../api';
const KEY = 'maxmarket.customer.intent';
const read = value => { try { const items = Array.isArray(value) ? value : JSON.parse(value || '[]'); return Array.isArray(items) ? items : []; } catch { return []; } };
export async function resumeCustomerIntent(session) {
  let cart = normalizeCart(read(session.cart)), favorites = read(session.favorites), intent;
  try { intent = JSON.parse(sessionStorage.getItem(KEY)); sessionStorage.removeItem(KEY); } catch { /* Login is independent of an optional local continuation. */ }
  if (!intent || Date.now() - intent.createdAt > 30 * 60 * 1000) return { cart, favorites };
  const to = typeof intent.to === 'string' && intent.to.startsWith('/') && !intent.to.startsWith('//') ? intent.to : '/';
  if (intent.type === 'favorite-seller') {
    if (!Number.isSafeInteger(Number(intent.sellerId)) || Number(intent.sellerId) <= 0) return { cart, favorites };
    try {
      await saveFavoriteShop(Number(intent.sellerId), true);
      return { cart, favorites, to, notice: 'Продавец сохранён в избранном' };
    } catch {
      return { cart, favorites, to, notice: 'Не удалось сохранить продавца. Попробуйте снова.' };
    }
  }
  if (!Number.isInteger(Number(intent.productId))) return { cart, favorites };
  if (intent.type === 'choose-size') return { cart, favorites, to, notice: 'Вы вошли. Выберите подходящий размер.' };
  try {
    const product = normalizeProduct(await productApi.getById(intent.productId));
    if (intent.type === 'favorite') {
      if (!favorites.some(p => Number(p.id) === Number(product.id))) favorites = [...favorites, product];
      return { cart, favorites, to, notice: 'Товар сохранён в избранное' };
    }
    const variant = product.variants?.find(v => Number(v.id) === Number(intent.variantId));
    if (!variant || variant.stock <= 0 || getRetailPrice(product, variant) <= 0) throw new Error('Unavailable');
    cart = cartReducer({ items: cart }, { type: 'ADD_TO_CART', payload: { ...product, selectedVariantId: variant.id, selectedSize: variant.size, price: getRetailPrice(product, variant), stock: variant.stock } }).items;
    if (intent.type === 'buy-now') cart = cartReducer({ items: cart }, { type: 'SELECT_ONLY', payload: variant.id }).items;
    return { cart, favorites, to: intent.type === 'buy-now' ? '/checkout' : to, notice: 'Товар добавлен в корзину' };
  } catch { return { cart, favorites, to, notice: 'Не удалось добавить товар. Проверьте его наличие и повторите действие.' }; }
}
